import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams,useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import SearchSvg from '../../svg/admin/Search';
import AddSvg from '../../svg/admin/Add';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchSchoolMissions } from '../../services/schoolMissions.service';
import { studentFetchStudentMissions } from '../../services/studentMissions.service';
import { getStudentScore, getTotalScore } from '../../util/mission';
function Component(props) {
  const {  } = useParams();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [data,setdata] = useState(null)
  const [isLoading,setisLoading]=useState(false)
  const [total,settotal]=useState(0)


  const filter= searchParams.get('filter')|| '全部';
  const page= parseInt(searchParams.get('page'))||1;
  const limit= 10
  const totalPage = Math.ceil(total/limit)||1

  const handleSelectPage=(p)=>async ()=>{
    if(p > totalPage || p < 1) return;
    searchParams.delete('page')
    searchParams.set('page', p)
    setSearchParams(searchParams)
}

  const fetchData=async(force=false)=>{
    if(isLoading&&!force)return
    setisLoading(true)
    const filter={}
    let result = await studentFetchStudentMissions(props.token.token,{status:'已完成'},{limit,skip:(page-1)*limit});
    if(result.result){
        setdata(result.result)
        settotal(result.count||0)
    }else{
        alert('Fetch data error')
    }
    setisLoading(false)
  }


  const onSelectFilter=(item,index)=>{
    searchParams.delete('filter')
    searchParams.delete('page')
    searchParams.set('filter', item)
    searchParams.set('page', 1)
    setSearchParams(searchParams)
  }


  useEffect(() => {
    const timer = setTimeout(fetchData, 500)
    // const interval = setInterval(fetchData,1000*30)
    return () => {
        clearTimeout(timer)
        // clearInterval(interval)
    }
  },[searchParams])



  const isMobile=window.innerWidth<1024

  return (
    <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]' style={{overflowY:"auto",gap:isMobile?'8px':'16px',padding:isMobile?'4px':'16px'}}>
        {/*title, filter, serach box*/}
        <div className='flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap' style={{padding:isMobile?'4px':'16px'}}>
            <div className='text-[#212121] text-[20px] font-[700]' style={{fontSize:isMobile?16:20}}>任務結果數據</div>
            <div className='flex flex-row items-center gap-[8px] flex-wrap'>
                {/* <DropDownMenu select={onSelectFilter} value={filter} options={['全部','1','2','3']}/>
                <div className='text-[14px] py-[8px] px-[16px] rounded-[7px] gap-[4px] flex flex-row' style={{border:'.5px solid #00000080'}}>
                    <SearchSvg/>
                    <input placeholder='搜尋'/>
                </div> */}
            </div>
        </div>
        {/*end of title, filter, serach box*/}


        {/*list of data*/}
        <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px]' style={{padding:isMobile?'4px':'16px',fontSize:isMobile?'10px':'14px'}}>
            <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{borderBottom:'1px solid #D1D1D1'}}>
                <div className='flex-1'>閲讀任務名稱</div>
                <div className='flex-1'>分類</div>
                <div className='flex-1'>任務</div>
                <div className='flex-1'>時間</div>
                <div className='flex-1'>狀態</div>
                <div className='flex-1'>分數</div>
                <div className='flex-1'>完成時間</div>
                <div className='' style={{width:isMobile?24:32}}></div>
            </div>
            {data?.map((item,index)=>
                <div key={item?._id||index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{borderBottom:'1px solid #D1D1D1'}}>
                    <div className='flex-1'>{item?.name}</div>
                    <div className='flex-1'>{item?.category}</div>
                    <div className='flex-1'>{item?.mission}</div>
                    <div className='flex-1'>{item?.time||'-'} 分鐘</div>
                    <div className='flex-1 flex flex-row'>
                        <div className='rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]' style={{paddingLeft:isMobile?4:24,paddingRight:isMobile?4:24,paddingTop:isMobile?2:6,paddingBottom:isMobile?2:6,fontSize:isMobile?8:12}}>
                            {item.status}
                        </div>
                    </div>
                    <div className='flex-1 flex flex-row'>
                        {getStudentScore(item?.questions)}/{getTotalScore(item?.questions)}
                    </div>
                    <div className='flex-1 flex flex-row'>
                        {item?.finishTime?new Date(item?.finishTime).toLocaleString():'-'}
                    </div>
                    <div onClick={()=>{navigate(`/platform/studentmissions/${item?._id}`)}} className=' bg-[#FFD8D0] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5]' style={{width:isMobile?24:32,height:isMobile?24:32}}>
                        <MoreSvg/>
                    </div>
                </div>
            )}
        </div>
        {/*end of list of data*/}
        <PageSelector
            handleSelectPage={handleSelectPage}
            page={page}
            total={total}
            totalPage={totalPage}
        />
        {isLoading&&<LoadingPage/>}
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  